(function(){
    'use strict';
    angular.module('Directives').directive('bbaTimeInput', bbaTimeInput);
    bbaTimeInput.$injecjt = [];

    function bbaTimeInput(){
        return {
            restrict: 'E',
            templateUrl: '/templates/directives/form-components/bba-time-input.html',
            replace: true,
            scope: {
                ngModel: '='
            },
            link: bbaTimeInputLink
        }

        function bbaTimeInputLink($scope){
            $scope.timeAmPm = ['AM', 'PM'];
            $scope.hourOpt = [];
            $scope.minuteOpt = [];

            init();

            function init() {
                initHoursOpt();
                initMinutesOpt();
            }

            function initHoursOpt() {
                for (let i = 1; i < 13; i++) {
                    if (i < 10) {
                        $scope.hourOpt.push(`0${i}`);
                        continue;
                    }
                    $scope.hourOpt.push(i);
                }
            }

            function initMinutesOpt() {
                for (let i = 1; i < 61; i++) {
                    if (i < 10) {
                        $scope.minuteOpt.push(`0${i}`);
                        continue;
                    }
                    $scope.minuteOpt.push(i);
                }
            }
        }
    }
})()



// WEBPACK FOOTER //
// ./js/directives/form-components/bbaTimeInput.js